export default __webpack_public_path__ + "static/media/title_zh_tw_pc.61a01e73.png";